/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DoctorApplicationStatusEnum = {
    New: 'New',
    Approved: 'Approved',
    DataRequested: 'Data Requested',
    Rejected: 'Rejected'
} as const;
export type DoctorApplicationStatusEnum = typeof DoctorApplicationStatusEnum[keyof typeof DoctorApplicationStatusEnum];


export function instanceOfDoctorApplicationStatusEnum(value: any): boolean {
    return Object.values(DoctorApplicationStatusEnum).includes(value);
}

export function DoctorApplicationStatusEnumFromJSON(json: any): DoctorApplicationStatusEnum {
    return DoctorApplicationStatusEnumFromJSONTyped(json, false);
}

export function DoctorApplicationStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorApplicationStatusEnum {
    return json as DoctorApplicationStatusEnum;
}

export function DoctorApplicationStatusEnumToJSON(value?: DoctorApplicationStatusEnum | null): any {
    return value as any;
}

